export class BettingGatewayConfigurations {
    constructor(param) {
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}
//# sourceMappingURL=BettingGatewayConfigirations.js.map